<template>
  <section>
    <div class="container">
      <PrimarySectionTitle>
        <div class="side-by-side">
          <h2 class="carret-right">Ao Vivo</h2>
          <a href="#">ver mais</a>
        </div>
      </PrimarySectionTitle>
      <div class="row">
        <div class="col-lg-3 col-6 mb-3">
          <CourseThumbBox live="1" />
        </div>
        <div class="col-lg-3 col-6 mb-3">
          <CourseThumbBox live="1" />
        </div>
        <div class="col-lg-3 col-6 mb-3">
          <CourseThumbBox live="1" />
        </div>
        <div class="col-lg-3 col-6 mb-3">
          <CourseThumbBox live="1" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import PrimarySectionTitle from '@/components/layout/PrimarySectionTitle'
  import CourseThumbBox from '@/components/course/CourseThumbBox'


  export default {
    components: {
      PrimarySectionTitle,
      CourseThumbBox,
    }
  }
</script>
